module.exports = __webpack_public_path__ + "static/media/login_logo.925ae702.png";